import { render, staticRenderFns } from "./FormAnnualTaxWizard.vue?vue&type=template&id=35436f7d&scoped=true"
import script from "./FormAnnualTaxWizard.vue?vue&type=script&lang=js"
export * from "./FormAnnualTaxWizard.vue?vue&type=script&lang=js"
import style0 from "./FormAnnualTaxWizard.vue?vue&type=style&index=0&id=35436f7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35436f7d",
  null
  
)

export default component.exports